require('jquery');
import frescojs from '@staaky/fresco';
require('@staaky/fresco/dist/css/fresco.css');

export function fresco() {
  frescojs.enable();
  if (window['frescoOpenLightbox']) {
    setTimeout(() => $(window['frescoOpenLightbox']).click(), 50);
  }
}
